export function zelisISAMLink(): string {
  let environmentCategory = 'p';
  let environmentNumber = '';

  const hostname = window.location.host.split('.cigna.com')[0];

  switch (hostname) {
    case 'd-hcpportal-0019':
      environmentCategory = 'd';
      environmentNumber = 'dev0019';
      break;
    case 'd-hcpportal-0031':
      environmentCategory = 'd';
      environmentNumber = '0031';
      break;
    case 'd-hcpportal-0032':
      environmentCategory = 'd';
      environmentNumber = '0032';
      break;
    case 'a-hcpportal-0035':
      environmentCategory = 'a';
      environmentNumber = '0035';
      break;
    case 'a-hcpportal-0036':
      environmentCategory = 'a';
      environmentNumber = '0036';
      break;
    case 'cignaforhcp':
    case 'chk-cignaforhcp':
      environmentCategory = 'p';
      break;
  }

  return `/isam/sps/chcp-${environmentCategory}${
    environmentNumber ? `-${environmentNumber}` : ''
  }-idp-zelis/saml20/logininitial?PartnerId=Zelis`;
}
